import {
   Component,
   OnInit,
   AfterViewInit,
   OnDestroy,
   ViewChildren,
   QueryList,
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   ViewChild
} from '@angular/core';
import { ShellClientService } from 'projects/shared-components/shell-communication/shell-client.service';
import { MessageBusService } from 'projects/shared-components/message-bus.service';
import { ToastrService } from 'ngx-toastr';
import { AccessControlService } from 'projects/shared-components/access-control-service.class';
import {from, Observable, Subject} from 'rxjs';
import { SettingsStorageService } from '../../../../shared-components/settings-storage-service.service';
import { LayoutComponent } from '../../../../shared-components/layout/layout.component';
import { LayoutTab } from '../../../../shared-components/layout/layout-tabs/layout-tab';
import { WorkspaceComponent } from '../../../../shared-components/workspace/workspace.component';
import { PinnedPanelsService } from '../../../../shared-components/workspace/pinned-panels.service';
import { TerminalExposureChangedUIMessage } from 'projects/shared-components/ui-messages/terminal-exposure-changed-ui-message.interface';
import { EtsConstants } from 'projects/shared-components/ets-constants.const';
import { ProtocolCommand } from 'projects/shared-components/service-model/protocol-command.interface';
import { MasterExit } from 'projects/shared-components/shell-communication/operations/group-exits/master-exit.class';
import { ILayoutSection } from '../../../../shared-components/layout/layout-section';
import { Logger } from 'projects/shared-components/logging/logger.interface';
import { CloseTerminalPositions } from 'projects/shared-components/shell-communication/operations/terminals/close-terminal-positions.class';
import {
   InitialWorkspaceInitializedUIMessage
} from 'projects/shared-components/ui-messages/initial-workspace-initialized-ui-message.interface';
import { takeUntil } from 'rxjs/operators';
import { ShellStatusPollingUIMessage } from 'projects/shared-components/ui-messages/shell-status-polling-ui-message.interface';
import { TerminalDto } from 'projects/shared-components/shell-communication/dtos/terminal-dto.class';
import {
   EventStreamConnectionChangedUIMessage
} from 'projects/shared-components/ui-messages/event-stream-connection-changed-message-ui-message.interface';
import { LoggerService } from 'projects/shared-components/logging/logger-factory.service';
import { LayoutsSortEventArgs } from 'projects/shared-components/layout/layout-sort/layouts-sort-event-args';
import {
   GetRecentPivots, GetRecentPivotsReply,
   RequestLoginIssuesReport
} from 'projects/shared-components/shell-communication/shell-operations-protocol';
import {QuoteLimitDto, ServerTimeMessageDto} from 'projects/shared-components/shell-communication/shell-dto-protocol';
import {DetectMethodChanges, isVoid} from 'projects/shared-components/utils';
import {TradingInstrumentsService} from 'projects/shared-components/trading-instruments/trading-instruments-service.interface';
import { SessionService } from 'projects/shared-components/authentication/session-service.service';
import { DismissToken } from 'projects/shared-components/authentication/operations/dismiss-token.class';
import { AuthServiceClientService } from 'projects/shared-components/authentication/auth-service-client.service';
import { LocationService } from 'projects/shared-components/location.service';
import {
   NormalizingCalculatorComponent
} from "../../../../shared-components/options-pricing-grid/normalizing-calculator/normalizing-calculator.component";
import {EtsLinkClickedMessage} from "../host-menu/host-menu.component";
import {QuoteGeneratorService} from "../../../../shared-components/quote-generator/quote-generator.service";
import {TimestampsService} from "../../../../shared-components/timestamps.service";
import {ApplicationSettingsService} from "../../../../shared-components/app-settings/application-settings.service";
import {SettlementPriceService} from "../../../../shared-components/hedging-grid/settlement-price.service";
import {DateTime} from "luxon";
import {SessionSyncOverlayService} from '../global-services/session-sync-overlay.service';
import {
    APG_SELECT_PORTFOLIO_REQUEST_TOPIC,
    COLLARS_SELECT_COMBO_REQUEST_TOPIC,
    HG_SELECT_PORTFOLIO_REQUEST_TOPIC,
    PHA_SELECT_PORTFOLIO_REQUEST_TOPIC,
    OPEN_SUBJECT_REQUEST_TOPIC,
    OpenSubjectRequest
} from 'projects/shared-components/action-board/action-board.model';
import {OPEN_ACTION_BOARD_REQUEST_TOPIC} from 'projects/shared-components/action-board/action-board-footer-badge.component';
import {
    OPEN_OR_ACTIVATE_MENU_TYPE,
    PANELS_PROBE_TOPIC,
    WorkspacePanelsMenuItemClickedUIMessage,
    WorkspacePanelsProbe,
    WorkspacePanelsProbeHit
} from 'projects/shared-components/workspace/panels-menu/workspace-panels-menu-item-clicked-message';
import {WorkspacePanels} from 'projects/shared-components/workspace/panels-menu/workspace-panels';

interface HostSecurityContext {
   currentMarketPrices: boolean;
   masterExit: boolean;
   terminalExit: boolean;
   sessionPnL: boolean;
   accumulatedPnL: boolean;
   gatewaysManager: boolean;
   menuButton: boolean;
   tradeButton: boolean;
   serverTimePanel: boolean;
   totalStrategiesIssues: boolean;
   sessionMessages: boolean;
   unaccountedData: boolean;
   jobsTracker: boolean;
   quoteRateLimiter: boolean;
   actionBoard: boolean;
}

@Component({
   templateUrl: './host.component.html',
   styleUrls: ['./host.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebtraderHostComponent implements OnInit, AfterViewInit, OnDestroy {
   constructor(
      private _changeDetector: ChangeDetectorRef,
      private _accessControlService: AccessControlService,
      private _shellServiceClient: ShellClientService,
      private _messageBus: MessageBusService,
      private _toastr: ToastrService,
      private _userSettingsService: SettingsStorageService,
      private _sessionService: SessionService,
      private _authClient: AuthServiceClientService,
      private _locationService: LocationService,
      private _qgService: QuoteGeneratorService,
      loggerService: LoggerService,
      private _timestampsService: TimestampsService,
      private readonly _applicationSettings: ApplicationSettingsService,
      private readonly _settlementPriceService: SettlementPriceService,
      private readonly _tiService: TradingInstrumentsService,
      private readonly _sessionSyncOverlayService: SessionSyncOverlayService,
      private readonly _pinnedPanels: PinnedPanelsService,
   ) {
      this._logger = loggerService.createLogger('HostComponent');
      this._unsubscriber = new Subject();
      this.essConnectionLostMessage =
         'WARNING! EventStream Service connection is lost. Restoring...';
      this.shellOfflineMessage =
         'WARNING! Shell you were logged in to is currently offline. Please, contact your system administrator';
   }

   private _unsubscriber: Subject<any> = new Subject<any>();
   private _logger: Logger;
   private _settlmentPricePollingInterval: any;

   settlementPrice: number;

   get isSuperUser(): boolean {
      return this._sessionService.isSuperUser;
   }

   get isEtsHost(): boolean {
      return this._locationService.isEtsHost;
   }

   get isBackupServer(): boolean {
      return this._locationService.isBackupServer;
   }

   get isStagingServer(): boolean {
      return this._locationService.isStagingServer;
   }

   get isQgMode() :boolean {
      return this._sessionService.loginResult.isQuoteGeneratorShell;
   }


   get layoutSectionStyle(): { width: string, height: string } {
      let height = 37;

      if (this.isTradingPadVisible) {
         height += 142;
      }
      if (this.isEventStreamConnectionLost) {
         height += 20;
      }
      if (this.isShellOffline) {
         height += 20;
      }

      if (this.isBackupServer || this.isStagingServer) {
         height += 3;
      }
      
      return { width: '100%', height: `calc(100% - ${height}px` };
   }

   @ViewChildren(WorkspaceComponent) layoutChildren: QueryList<LayoutComponent>;

   layouts: LayoutTab[] = [];

   isTradingPadVisible: boolean;

   essConnectionLostMessage: string;

   shellOfflineMessage: string;

   securityContext: HostSecurityContext;

   @ViewChild(NormalizingCalculatorComponent)
   normalizingCalculator: NormalizingCalculatorComponent;

   //

   private _isEventStreamConnectionLost: boolean;
   
   get isEventStreamConnectionLost(): boolean { 
      return this._isEventStreamConnectionLost; 
   }
   
   set isEventStreamConnectionLost(value: boolean) {

      if (this._isEventStreamConnectionLost === value) {
         return;
      }

      this._logger.info(`ESS connection changed. IsConnected: ${!value}`);

      this._isEventStreamConnectionLost = value;

      // LEAK-1 — host 20s kill timer removed. Disconnect tolerance now
      // governed solely by ESS RECOVERY_WINDOW_SECONDS (90s) +
      // dismissed-token gate in EventStreamServer. Stale-overlay kickout
      // (SessionSyncOverlayService.STALE_OVERLAY_KICKOUT_MS) covers the
      // case where probes never pass after tab return. No client-side
      // forced logout on plain WS-down.
   }

   //

   isShellOffline = false;

   terminalSessionPnL: number;

   terminalAccumulatedPnL: number;

   selectedLayout: LayoutTab;

   groupExitDetails: {
      message?: string,
      command?: ProtocolCommand,
      isConfirmationVisible?: boolean
   } = {};

   
   isLayoutsSortDialogVisible: boolean;

   quoteCounter: string;

   ngOnInit(): void {

      this._pinnedPanels.resetSession();
      this.initSecurityContext();

      const layoutConfiguration = this._userSettingsService
          .getItem<any[]>(EtsConstants.storageKeys.layoutRootKey) || [];

      if (layoutConfiguration) {

         try {

            const lts: LayoutTab[] = layoutConfiguration.map(x => JSON.parse(x) as LayoutTab);
            lts.forEach(x => this.restoreParents(x.layoutRoot));
            this.layouts = lts;

         } catch (e) {

            this._userSettingsService.removeItem(EtsConstants.storageKeys.layoutRootKey);
            const data = { error: e.message, stack: e.stack };
            this._logger.error('Failed to restore layout', data);
            this._toastr.error('Failed to restore layout');

         } finally {

            //

         }

      }

      // CR-20260927-002: settled BEFORE the workspaces restore their panels (they do it on a timer),
      // so the first workspace of the first layout tab already knows it hosts the pinned board.
      this.designatePinnedPanelsWorkspace();

      this.isEventStreamConnectionLost = true;

      this.subscribeMessages();

      // CR-20260508-001 — start session-sync overlay. reset() before start()
      // because the singleton survives logout/login and may carry stale state.
      // CR-20260509-001 — start() also engages pause/resume gate; stop()
      // disengages. /app-only rule centralized in SessionSyncOverlayService.
      this._sessionSyncOverlayService.reset();
      this._sessionSyncOverlayService.start();

      const lastMessage = this._messageBus.getLastMessage<TerminalExposureChangedUIMessage>('TerminalExposureChangedUIMessage');
      
      if (lastMessage) {
         this.onTerminalExposureChanged(lastMessage.payload);
      }

      this._messageBus.of<EtsLinkClickedMessage>('EtsLinkClickedMessage')
          .subscribe((msg) => this.onEtsLinkClicked(msg.payload));

      // CR-20260922-001 — Action Board deep links: "open this subject in its panel" from a card, and
      // "open the board" from the footer badge. The host is the one place that knows the layouts.
      this._messageBus.of<OpenSubjectRequest>(OPEN_SUBJECT_REQUEST_TOPIC)
          .subscribe((msg) => this.onActionBoardOpenSubject(msg.payload));

      this._messageBus.of<any>(OPEN_ACTION_BOARD_REQUEST_TOPIC)
          .pipe(takeUntil(this._unsubscriber))
          .subscribe(() => this.openActionBoard());

      this._settlmentPricePollingInterval = setInterval(() => {

           let currentZoneTime = DateTime.local().setZone('America/New_York');

           const marketCloseTimeString = currentZoneTime.toFormat("yyyy-MM-dd") + 'T16:00:00';
           const currentTimeString = currentZoneTime.toISO({suppressMilliseconds: true, includeOffset: false});

           if (currentTimeString < marketCloseTimeString) {
               do {
                   currentZoneTime = currentZoneTime.minus({day: 1});
               } while (currentZoneTime.weekday === 6 || currentZoneTime.weekday === 7)
           }

           const todayDate = currentZoneTime.toFormat('yyyy-MM-dd');
           this._settlementPriceService.getSettlementPriceWithRequest(
               'SPX',
               todayDate
           ).then((x) => {
               this.settlementPrice = x;
               this._changeDetector.detectChanges();
           })
       }, 1000);

   }


   ngOnDestroy(): void {
      this.unsubscribeMessages();
      clearInterval(this._settlmentPricePollingInterval);
      // CR-20260509-001 — stop() also disengages pause/resume gate.
      this._sessionSyncOverlayService.stop();
   }


   @DetectMethodChanges()
   async ngAfterViewInit() {
      
      this._changeDetector.detach();

      try {
         await this._shellServiceClient.processCommand(new RequestLoginIssuesReport());
      } catch {
         this._toastr.error('Logon Report Request completed with errors');
      }
   }

   isTheoreticalStream(ticker: string) {
      return this._qgService.isTheoreticalPrices(ticker);
   }

   isAdjustedStream(ticker: string) {
      return ticker === 'SPX' && (this._timestampsService.isPreMarketHours()
         && this._applicationSettings.adjustSpxPriceOutsideOfMarketHours);
   }


   @DetectMethodChanges()
   onLayoutSelected(event: LayoutTab) {
      if (!event.isInitialized) {
         this.refreshTabLayoutOnInitialization(event.layoutRoot);
         event.isInitialized = true;
      }
      this.layouts.forEach(lt => lt.isActive = false);
      event.isActive = true;
      // Notify the OnPush layout tab strip when selection changes outside its own click handler.
      this.layouts = this.layouts.slice();
      this.selectedLayout = event;
      this.onLayoutChanged();
   }


   @DetectMethodChanges()
   onCloseTabRequest(event: LayoutTab) {
      const ix = this.layouts.indexOf(event);
      if (ix >= 0) {
         this._messageBus.publish({
            topic: 'LayoutTabClosed',
            payload: {
               layoutTabId: event.id
            },
            scopeId: event.id
         });
         this.layouts.splice(ix, 1);
      }
      if (this.layouts.length > 0) {
         this.onLayoutSelected(this.layouts[this.layouts.length - 1]);
      } else {
         this.selectedLayout = null;
      }

      this.onLayoutChanged();
   }


   @DetectMethodChanges()
   onAddTabRequest() {
      let layoutTab: LayoutTab;
      const hasRootLayout = !isVoid(this._userSettingsService.getItem(EtsConstants.storageKeys.layoutRootKey));
      if (!hasRootLayout) {
         layoutTab = new LayoutTab('Default', true);
         this.layouts.push(layoutTab);
      } else {
         layoutTab = new LayoutTab();
         this.layouts.forEach(x => x.isActive = false);
         this.layouts.push(layoutTab);
      }
      layoutTab.isActive = true;
      this.selectedLayout = layoutTab;
      this.onLayoutChanged();
   }


   onLayoutChanged() {
      this.designatePinnedPanelsWorkspace();
      setTimeout(() => {
         const layoutConfiguration = this.layouts.map(x => {
            const str = JSON.stringify(x, (k, v) => {
               if (k === 'parent' || k === 'isInitialized' || k === 'instance') {
                  return null;
               }
               return v;
            });
            return str;
         });
         
         if (layoutConfiguration) {
            this._userSettingsService.setItem(EtsConstants.storageKeys.layoutRootKey, layoutConfiguration);
         }            
      }, 1);
   }


   @DetectMethodChanges()
   onMasterExitPressed() {
      const cmd = new MasterExit();
      this.groupExitDetails.command = cmd;
      this.groupExitDetails.isConfirmationVisible = true;
      this.groupExitDetails.message = 'This will close all open positions on shell. Do you confirm?';
   }


   @DetectMethodChanges()
   onTerminalExitRequestPressed(term: TerminalDto) {
      const cmd = new CloseTerminalPositions(
         term.terminalId
      );
      this.groupExitDetails.command = cmd;
      this.groupExitDetails.isConfirmationVisible = true;
      this.groupExitDetails.message = `This will close all open positions on terminal "${term.displayName}". Do you confirm?`;
   }


   @DetectMethodChanges()
   onSortLayoutsRequest() {
      
      if (this.layouts.length <= 1) {
         return;
      }

      this.isLayoutsSortDialogVisible = !this.isLayoutsSortDialogVisible;
   }


   @DetectMethodChanges()
   onSortLayoutsCompleted(ev: LayoutsSortEventArgs) {
      if (ev) {

         ev.layouts.forEach(layout => {
            const oldLayoutIndex = this.layouts.findIndex((lt) => lt.id === layout.layoutId);
            if (oldLayoutIndex < 0) {
               return;
            }
            const layoutToReplace = this.layouts[layout.newIx];
            const layoutToSet = this.layouts[oldLayoutIndex];
            this.layouts[layout.newIx] = layoutToSet;
            this.layouts[oldLayoutIndex] = layoutToReplace;
         });

         this.onLayoutChanged();
      }

      this.isLayoutsSortDialogVisible = false;
   }


   @DetectMethodChanges()
   toggleTradingPad() {
      this.isTradingPadVisible = !this.isTradingPadVisible;
   }


   private unsubscribeMessages() {
      if (this._unsubscriber) {
         if (!this._unsubscriber) {
            this._unsubscriber.next();
            this._unsubscriber.complete();
         }
      }
   }


   @DetectMethodChanges()
   private onTerminalExposureChanged(message: TerminalExposureChangedUIMessage): void {
      
      if (!message.isOwnTerminal) {
         return;
      }

      this.terminalAccumulatedPnL = message.accumulatedTerminalTotal;
      this.terminalSessionPnL = message.sessionTerminalTotal;
   }


   @DetectMethodChanges()
   private refreshTabLayoutOnInitialization(layoutRoot: ILayoutSection) {
      if (!layoutRoot.subsections) {
         layoutRoot.size += 0.000000001;
         return;
      }

      layoutRoot.subsections.forEach(x => {
         x.size = x.size + 0.0000000001;
         if (x.subsections) {
            x.subsections.forEach(y => {
               this.refreshTabLayoutOnInitialization(y);
            });
         }
      });
   }

   @DetectMethodChanges()
   private restoreParents(layout: ILayoutSection) {
      if (layout.subsections) {
         for (const x of layout.subsections) {
            x.parent = layout;
            if (x.subsections) {
               for (const y of x.subsections) {
                  this.restoreParents(x);
               }
            }
         }
      }
   }

   
   @DetectMethodChanges()
   async confirmGroupExit(response: 'yes' | 'no') {
      if (response === 'no') {
         this.groupExitDetails = {};

         // this._changeDetector.detectChanges();

         return;
      }

      if (!this.groupExitDetails.command) {
         this._toastr.error('Group Exit Command is Not Defined');
         this.groupExitDetails = {};

         // this._changeDetector.detectChanges();

         return;
      }

      try {
         
         await this._shellServiceClient.processCommand(this.groupExitDetails.command);

      } catch (e) {
         
         const data = { command: this.groupExitDetails.command, error: (e.stack || e) };
         this._logger.error('Group exit failed', data);
         this._toastr.error('"Group Exit" command completed with errors');

      } finally {

         this.groupExitDetails = {};
         
      }
   }

   
   private initSecurityContext(): void {
      const isAvailable =
         (id) => this._accessControlService.isSecureElementAvailable(id);

      this.securityContext = {
         currentMarketPrices: isAvailable('465289b5-6930-41e1-8d57-5bd8d0b2ff9f'),
         accumulatedPnL: isAvailable('c387dcb2-913f-4877-8c12-c667e9d0502f') && !this._locationService.isTradingMasteryHost,
         sessionPnL: isAvailable('9248099c-6413-47cc-b889-aaea2206f6ad') && !this._locationService.isTradingMasteryHost,
         gatewaysManager: isAvailable('f8c8f4b0-6256-4ed3-b5f6-3dcdab11db14'),
         masterExit: isAvailable('d23f2758-4c51-4750-a353-7007f48d9580'),
         menuButton: isAvailable('495f03af-a9d2-4a9f-a461-d4af6517fc3e'),
         terminalExit: isAvailable('d3221ada-5b08-40f3-b357-d57ade528c86'),
         tradeButton: isAvailable('e430fec1-40d8-4f8c-aeee-ed61602e6088'),
         serverTimePanel: isAvailable('2d4317e0-f12a-4ec1-987a-0507ea5a56e9'),
         sessionMessages: isAvailable('9fba9be6-f3be-4622-910d-849041f80389'),
         totalStrategiesIssues: isAvailable('36e75f05-8df8-41a6-a52d-691ed89a8e97') && !this._locationService.isTradingMasteryHost,
         unaccountedData: isAvailable('600e90cf-e5c7-4448-9727-78744e0456dd') && !this._locationService.isTradingMasteryHost,
         jobsTracker: isAvailable('5aab5448-8f9b-40f4-b41d-a717bcd6781f') && !this._locationService.isTradingMasteryHost,
         quoteRateLimiter: this._sessionService.isSuperUser,
         // CR-20260922-001 — same GUID as the Action Board panel's grant.
         actionBoard: isAvailable('34f4a19b-8688-4a2d-9de4-c8ffccfdc7d7'),
      };
   }
   
   private subscribeMessages() {
      /* subscribe for event-stream events */
      this.unsubscribeMessages();

      this._unsubscriber = new Subject<any>();

      this._messageBus
          .of<InitialWorkspaceInitializedUIMessage>('InitialWorkspaceInitializedUIMessage')
         .pipe(takeUntil(this._unsubscriber))
         .subscribe(x => {
            if (this.layouts.length > 0) {
               const layoutTab = this.layouts[0];
               const layoutRoot = layoutTab.layoutRoot;
               if (layoutRoot.subsections.length > 0) {
                  const defaultSection = layoutRoot.subsections[0];
                  defaultSection.isInitial = false;
               }
            }
            this.onLayoutChanged();
         });

      this._messageBus
         .of<EventStreamConnectionChangedUIMessage>(
            'EventStreamConnectionChangedUIMessage'
         )
         .pipe(takeUntil(this._unsubscriber))
         .subscribe(x => {
            this.isEventStreamConnectionLost = !x.payload.isConnected;
            this._changeDetector.detectChanges();
         });

      this._messageBus
         .of<ShellStatusPollingUIMessage>('ShellStatusPollingUIMessage')
         .pipe(takeUntil(this._unsubscriber))
         .subscribe(x => {
            this.isShellOffline = !x.payload.isOnline;
            this._changeDetector.detectChanges();
         });

      this._messageBus
         .of<TerminalExposureChangedUIMessage>('TerminalExposureChangedUIMessage')
         .pipe(takeUntil(this._unsubscriber))
         .subscribe(message => this.onTerminalExposureChanged(message.payload));


      this._messageBus.of<ServerTimeMessageDto>('ServerTimeMessageDto')
         .pipe(takeUntil(this._unsubscriber))
         .subscribe(() => {
            if (this.isEventStreamConnectionLost) {
               this.isEventStreamConnectionLost = false;
            }
            this._changeDetector.detectChanges();
         });

      this._messageBus.of<QuoteLimitDto>('QuoteLimitDto')
          .pipe(takeUntil(this._unsubscriber))
          .subscribe(msg => {
             this.quoteCounter = msg.payload.count;
             this._changeDetector.detectChanges();
          });

      this._messageBus.of('Qg.StreamModeChanged')
          .pipe(takeUntil(this._unsubscriber))
          .subscribe(_ => this._changeDetector.detectChanges());
   }

   private onEtsLinkClicked(payload: EtsLinkClickedMessage) {
      if (payload.address.indexOf('normalizing-calculator') === -1) {
         return;
      }
      this.normalizingCalculator.show();
   }

   // CR-20260922-001. The SELECT request is published FIRST (the bus caches the last message), so a
   // panel that is only now being added finds it on boot; a panel already open takes it live.
   // CR-20260924-001 F4b: ONE panel takes it. The host probes every live workspace for panels of
   // the kind, picks the active one in the layout tab on screen (else any active, else the first),
   // stamps its id on the request and activates exactly that panel; with none open, a new panel is
   // added to the first workspace of the layout and takes the unstamped request on boot.
   private onActionBoardOpenSubject(request: OpenSubjectRequest): void {
      if (!request) {
         return;
      }

      let typeCode: WorkspacePanels;
      let selectTopic: string;
      if (request.panel === 'APG') {
         typeCode = WorkspacePanels.AdjustmentPricingGridPanel;
         selectTopic = APG_SELECT_PORTFOLIO_REQUEST_TOPIC;
      } else if (request.panel === 'HedgingGrid') {
         typeCode = WorkspacePanels.HedgingGrid;
         selectTopic = HG_SELECT_PORTFOLIO_REQUEST_TOPIC;
      } else if (request.panel === 'PortfolioHedgingAnalysis') {
         // CR-20260929-001: "Analyze Hedging..." on a Collars portfolio row.
         typeCode = WorkspacePanels.PortfolioHedgingAnalysis;
         selectTopic = PHA_SELECT_PORTFOLIO_REQUEST_TOPIC;
      } else if (request.panel === 'Collars') {
         // CR-20260930-001 M4 (owner): an analysis overdue card opens COLLARS - the
         // acquisition happens there - with the combo (request.comboId) auto-selected.
         typeCode = WorkspacePanels.Collars;
         selectTopic = COLLARS_SELECT_COMBO_REQUEST_TOPIC;
      } else {
         return;
      }

      const layoutId = request.sourceLayoutTabId;
      if (layoutId && !this.layouts.some(x => x.id === layoutId)) {
         this._toastr.warning('The Action Board Layout Is No Longer Available');
         return;
      }
      const target = this.probeTargetPanel(typeCode, layoutId);
      const targeted: OpenSubjectRequest = {...request, targetPanelId: target ? target.panelId : null};
      this._messageBus.publish({topic: selectTopic, payload: targeted});
      this.openOrActivatePanel(typeCode, target, layoutId);
   }

   @DetectMethodChanges()
   private openActionBoard(): void {
      if (!this.securityContext.actionBoard) {
         return;
      }
      if (this._locationService.isTradingMasteryHost) {
         const firstLayout = this.layouts[0];
         if (!firstLayout) {
            return;
         }
         this._pinnedPanels.reopenActionBoard();
         this.onLayoutSelected(firstLayout);
         this.openOrActivatePanel(WorkspacePanels.ActionBoard, null, firstLayout.id);
         return;
      }
      this.openOrActivatePanel(WorkspacePanels.ActionBoard);
   }

   /** Activate the given open panel, or add one of the type to the first workspace of the layout when none is open. */
   private openOrActivatePanel(typeCode: WorkspacePanels, target: WorkspacePanelsProbeHit | null = this.probeTargetPanel(typeCode), layoutId?: string): void {
      let workspaceId: string | null;
      if (target) {
         workspaceId = target.workspaceId;
      } else {
         const layout = layoutId ? this.layouts.find(x => x.id === layoutId)
             : this.selectedLayout || this.layouts.find(x => x.isActive) || this.layouts[0];
         workspaceId = this.firstWorkspaceId(layout?.layoutRoot);
      }
      if (!workspaceId) {
         this._toastr.warning('No workspace to open the panel in');
         return;
      }
      this._messageBus.publish({
         topic: 'WorkspacePanelsMenuItemClickedUIMessage',
         payload: new WorkspacePanelsMenuItemClickedUIMessage(
             typeCode.toString(), OPEN_OR_ACTIVATE_MENU_TYPE, workspaceId, target ? target.panelId : null)
      });
   }

   /** F4b: the one open panel of the kind that should take a deep link, or null when none is open. */
   private probeTargetPanel(typeCode: WorkspacePanels, layoutId?: string): WorkspacePanelsProbeHit | null {
      const probe: WorkspacePanelsProbe = {typeCode, found: []};
      this._messageBus.publish({topic: PANELS_PROBE_TOPIC, payload: probe});

      // A card must never reuse a panel belonging to another layout.
      if (layoutId) {
         const local = probe.found.filter(x => x.layoutTabId === layoutId);
         return local.find(x => x.isActive) || local[0] || null;
      }
      const onScreenTab = this.selectedLayout?.id;
      return probe.found.find(x => x.isActive && x.layoutTabId === onScreenTab)
          || probe.found.find(x => x.isActive)
          || probe.found[0]
          || null;
   }

   // CR-20260927-002 (owner ruling B): pinned panels live in the first workspace of the FIRST
   // layout tab, as the tabs are ordered now. Recomputed on every layout change.
   private designatePinnedPanelsWorkspace(): void {
      const first = this.layouts.length ? this.layouts[0] : null;
      this._pinnedPanels.setDesignatedWorkspace(this.firstWorkspaceId(first?.layoutRoot));
   }

   private firstWorkspaceId(section: ILayoutSection | null | undefined): string | null {
      if (!section) {
         return null;
      }
      // Only a LEAF hosts a workspace component; a container section made by a split may still
      // carry a workspaceId of its own (see LayoutTab.makeDefaultLayout), which no workspace answers.
      if (section.workspaceId && !section.subsections) {
         return section.workspaceId;
      }
      for (const sub of section.subsections || []) {
         const id = this.firstWorkspaceId(sub);
         if (id) {
            return id;
         }
      }
      return null;
   }

   @DetectMethodChanges()
   async getPivots() {

      const qry = new GetRecentPivots(
          'SPX',
          '5 min',
          'Up',
          'Up',
          'Close'
      );

      const result = await this._shellServiceClient.processQuery<GetRecentPivotsReply>(qry);

      console.log(result);
   }

   get currentEsContract(): string {
      return this._tiService.currentEsContract;
   }
}
